<template>
    <div
        class="ppv2-flex ppv2-flex-wrap ppv2-w-full ppv2-step-wrapper md:ppv2-gap-[3.125vw]"
        :style="{ paddingLeft: normalizeSize(55) }"
    >
        <div class="form-section">
            <HeaderStep :step="step" :sizes="sizes" />

            <!-- Mise en ligne et affichage Section -->
            <DashedCard
                :marginTop="0"
                :marginBottom="30"
                minHeight="100px"
                :custom-style="{ padding: normalizeSize(24, true), justifyContent: 'center' }"
            >
                <template #title>
                    <span class="poppinsLight ppv2-text-black">{{ $t('serie.step5.online_display') }}</span>
                </template>
                <template #content>
                    <div class="ppv2-space-y-4">
                        <!-- Visibility Toggle -->
                        <div class="ppv2-flex ppv2-items-center ppv2-gap-3">
                            <BaseSwitch
                                id="visible_online"
                                v-model="options.visible_online"
                                :label="$t('serie.step5.visible_label')"
                                :label-left="null"
                                @focus="activeField = 'visibility'"
                                @blur="activeField = null"
                            />
                        </div>
                    </div>
                </template>
            </DashedCard>

            <!-- Options de billetterie Section -->
            <DashedCard
                :marginTop="0"
                :marginBottom="30"
                minHeight="100px"
                :custom-style="{ padding: normalizeSize(24, true), justifyContent: 'center' }"
            >
                <template #title>
                    <span class="poppinsLight ppv2-text-black">{{ $t('serie.step5.ticketing_options') }}</span>
                </template>
                <template #content>
                    <div class="ppv2-space-y-4">
                        <!-- Undated Ticket Toggle -->
                        <div class="ppv2-flex ppv2-items-center ppv2-gap-3">
                            <BaseSwitch
                                id="as_undated_ticket"
                                v-model="options.as_undated_ticket"
                                :label="$t('serie.step5.undated_label')"
                                :label-left="null"
                                @focus="activeField = 'undated'"
                                @blur="activeField = null"
                            />
                        </div>
                    </div>
                </template>
            </DashedCard>

            <!-- Action Buttons -->
            <div class="form-actions" :class="{ '!ppv2-justify-end': complited }">
                <BackButton v-show="!complited" type="button" @click="$emit('previous-step')" />
                <BaseButton id="submit" type="button" variant="primary" @click="saveAndFinish" :loading="loading">
                    {{ complited ? $t('common.save') : $t('experience.next') }}
                </BaseButton>
            </div>
        </div>
        <PreviewSerie :active-field="activeField" :step="step" />
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import BaseButton from '../../../Shared/BaseButton.vue'
import BackButton from '../../../Shared/BackButton.vue'
import BaseSwitch from '../../../Shared/BaseSwitch.vue'
import DashedCard from '../../../Shared/DashedCard.vue'
import PreviewSerie from './PreviewSerie.vue'
import HeaderStep from './HeaderStep.vue'
import normalizeSize from '../../../../utils/normalizeSize'

export default {
    name: 'SerieStep5',
    components: {
        BaseButton,
        BaseSwitch,
        DashedCard,
        BackButton,
        PreviewSerie,
        HeaderStep,
    },
    props: {
        step: { type: Object, required: true },
        sizes: { type: Object, required: true },
        id: { type: [Number, String], default: null },
        complited: { type: [Boolean], default: false },
    },
    data() {
        return {
            activeField: null,
            initialDataString: null,
        }
    },
    mounted() {
        this.initialDataString = this.getFormDataString()
    },
    computed: {
        ...mapGetters('serie', ['options', 'isEditMode', 'loading']),
        options: {
            get() {
                return this.$store.getters['serie/options']
            },
            set(value) {
                this.$store.dispatch('serie/setOptions', value)
            },
        },
    },
    methods: {
        ...mapActions('serie', ['saveSerie', 'resetStore']),
        normalizeSize,

        getFormDataString() {
            return JSON.stringify({
                visible_online: this.options.visible_online,
                as_undated_ticket: this.options.as_undated_ticket,
            })
        },

        hasChanges() {
            if (!this.initialDataString) return false
            return this.initialDataString !== this.getFormDataString()
        },

        resetInitialState() {
            this.initialDataString = this.getFormDataString()
        },

        revertChanges() {
            if (!this.initialDataString) return
            const data = JSON.parse(this.initialDataString)
            this.$store.dispatch('serie/setOptions', {
                visible_online: data.visible_online,
                as_undated_ticket: data.as_undated_ticket,
            })
        },

        goToList() {
            const baseUrl = `${window.location.protocol}//${window.location.host}`
            window.location.href = `${baseUrl}/back-office/v3/experience`
        },

        async saveAndFinish() {
            // Save to API with error handling
            try {
                await this.saveSerie()

                // Show success message
                this.$toast?.success?.(this.$t('serie.step5.success_save'))

                // Redirect to list only if save was successful
                this.goToList()
            } catch (error) {
                this.$toast.error(error.response.data.message)
            }
        },
    },
}
</script>

<style scoped>
.form-section {
    flex: 1;
}

.form-actions {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    margin-top: 40px;
}
</style>
